import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";
import {Loan} from "Loans/interface";

export interface NocDetails {
  pdfData: string;
  fileName: string;
  contentType: string;
}

export const getUserLoans = async (): Promise<{loans: Loan[], status: string}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kautilya/user-loans`,
    method: "get",
  });
  return res.data;
};

export const getPreApprovedProductList = async (): Promise<string[]> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: "/corleone/pre-approved-products",
    method: "GET",
  });
  return res.data.preApprovedProducts;
};

export const downloadEkagrataNoc = async (
  loanId: number,
): Promise<NocDetails> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: "/lender-push/generate-noc",
    method: "POST",
    data: {
      loan_id: loanId,
    },
  });
  return res.data;
};
